<h2>{{ componentTitle }}</h2>
<p-table #dt
			#table
			[value]="customerServiceHistorysearchResults"
			[columns]="cols"
			[rows]="rows"
			[paginator]="true"
			[lazy]="true"
			[totalRecords]="totalRecords"
			[lazyLoadOnInit]="false"
			(onLazyLoad)="loadDataLazy($event)"
			[globalFilterFields]="['receiptId', 'businessTransactionCompletionDate', 'businessUnit', 'businessTransactionType', 'businessTransactionDetails', 'agent', 'customerName']"
			styleClass="mvd_table--notfixed">
	<ng-template pTemplate="caption" *ngIf="filterEnabled">
		<div class="row">
			<div class="col-sm-6 col-md-3">
				<input class="mvd_form-control" type="text" autocomplete="off" placeholder="Filter..." (input)="dt.filterGlobal($event.target.value, 'contains')">
			</div>
		</div>
	</ng-template>
	<ng-template pTemplate="emptymessage">
		<tr>
			<td [attr.colspan]="9">
				No records found
			</td>
		</tr>
	</ng-template>
	<ng-template pTemplate="header" let-columns>
		<tr>
			<th *ngFor="let col of columns" [pSortableColumn]="filterEnabled ? col.field : undefined">
				{{col.header}}
				<p-sortIcon *ngIf="filterEnabled" [field]="col.field"></p-sortIcon>
			</th>
			<th *ngIf="!hideActions" class="w--actions">Actions</th>
		</tr>
	</ng-template>
	<ng-template pTemplate="body" let-data>
		<tr [pSelectableRow]="data">
			<td>{{ data.receiptId }}</td>
			<td>{{ data.businessTransactionCompletionDate | date:'M/d/yyyy' }}</td>
			<td>{{ data.businessUnit }}</td>
			<td>{{ data.businessTransactionType }}</td>
			<td>{{ data.businessTransactionDetails }}</td>
			<td>{{ data.agentName }}</td>
			<td>{{ data.customerName }}</td>
			<td class="text-right">{{ data.amount | currency:'USD':'symbol-narrow':'.2-2' }}</td>
			<td *ngIf="!hideActions" class="w--actions text-center">
				<div class="icon--spinner loading" title="Processing" *ngIf="data.wipStatusTypeId === null"></div>
				<a class="icon--upload" title="Select Service" (click)="launchDocuments(data.businessTransactionNumber)" href="javascript:void(0);"></a>
				<a class="icon--alert--retry" href="javascript:void(0);" title="Retry" (click)="retryCompleteBusinessTransaction(data)" *ngIf="wipStatusType.AwaitingPostFinalize.id == data.wipStatusTypeId"><i class="material-icons">error</i></a>
				<a class="icon--select" title="Select" (click)="getArtifacts(data.businessTransactionNumber, data.businessTransactionDetails)" *ngIf="wipStatusType.ServiceComplete.id == data.wipStatusTypeId" href="javascript:void(0);"></a>
			</td>
		</tr>
	</ng-template>
</p-table>